import { type JobsApi } from '@/features/jobs/api/job-api'
import {
  GetJobRatingStatusRequest,
  SubmitProRatingRequest,
} from '@taxfyle/api-internal/internal/job_rating_pb'
import {
  type JobRatingStatus,
  mapJobRatingStatusProtoToProps,
} from './ratings-mappers'
import { Id } from '@/infra/id'

export class RatingsStore {
  constructor(private readonly _api: JobsApi) {}

  async fetchJobRatingStatus(
    jobId: Id,
    signal?: AbortSignal,
  ): Promise<JobRatingStatus> {
    const request = new GetJobRatingStatusRequest().setJobId(Id.assert(jobId))

    const response = await this._api.ratings.getJobRatingStatus(request)
    signal?.throwIfAborted()
    return mapJobRatingStatusProtoToProps(response)
  }

  async submitProRating({
    jobId,
    rating,
    proUserId,
    comment,
  }: SubmitProRatingOptions): Promise<void> {
    const request = new SubmitProRatingRequest()
      .setJobId(Id.assert(jobId))
      .setRating(rating)
      .setComment(comment)
      .setProviderUserPublicId(Id.assert(proUserId))

    await this._api.ratings.submitProRating(request)
  }
}

export interface SubmitProRatingOptions {
  jobId: Id
  rating: number
  comment: string
  proUserId: Id
}
